export const containers = [
  {
    type: "grid",
    label: "栅格",
    category: "container",
    widgetList: [],
    options: {
      gutter: 12,
      colHeight: null, //栅格列统一高度属性，用于解决栅格列设置响应式布局浮动后被挂住的问题！！
      customClass: "", //自定义css类名
    },
  },

  {
    type: "table",
    label: "表格",
    category: "container",
    internal: true,
    widgetList: [],
    options: {
      customClass: "", //自定义css类名
    },
  },

  {
    type: "grid-col",
    category: "container",
    internal: true,
    widgetList: [],
    options: {
      span: 12,
      offset: 0,
      push: 0,
      pull: 0,
      // md: 12,
      // sm: 12,
      // xs: 12,
    },
  },

  {
    type: "table-cell",
    category: "container",
    internal: true,
    widgetList: [],
    merged: false,
    options: {
      name: "",
      cellWidth: "",
      cellHeight: "",
      colspan: 1,
      rowspan: 1,
      customClass: "", //自定义css类名
    },
  },
];

export const fields = [
  {
    type: "input",
    label: "单行输入",
    hidden: false,
    options: {
      labelAlign: "",
      defaultValue: "",
      placeholder: "",
      labelWidth: null,
      disabled: false,
      allowClear: true,
      required: false,
      requiredHint: "",
      validation: "",
      validationHint: "",
      //-------------------
      maxLength: null,
      prefixIcon: "",
      suffixIcon: "",
      //-------------------

      onMounted: "",
      onInput: "",
      onChange: "",
      onFocus: "",
      onBlur: "",
      onValidate: "",
    },
  },

  {
    type: "textarea",
    label: "多行输入",
    hidden: false,
    options: {
      labelAlign: "",
      rows: 3,
      defaultValue: "",
      placeholder: "",
      labelWidth: null,
      disabled: false,
      required: false,
      requiredHint: "",
      validation: "",
      validationHint: "",
      //-------------------
      maxLength: null,
      showCount: false,
      //-------------------

      onMounted: "",
      onInput: "",
      onChange: "",
      onFocus: "",
      onBlur: "",
      onValidate: "",
    },
  },

  {
    type: "number",
    label: "计数器",
    hidden: false,
    options: {
      labelAlign: "",
      defaultValue: 0,
      placeholder: "",
      labelWidth: null,
      disabled: false,
      required: false,
      requiredHint: "",
      validation: "",
      validationHint: "",
      prefixIcon: "",
      //-------------------
      min: -100000000000,
      max: 100000000000,
      precision: 0,
      step: 1,
      //-------------------

      onMounted: "",
      onChange: "",
      onFocus: "",
      onBlur: "",
      onValidate: "",
    },
  },

  {
    type: "password",
    hidden: false,
    label: "密码",
    options: {
      labelAlign: "",
      defaultValue: "",
      labelWidth: null,
      disabled: false,
      allowClear: true,
      required: false,
      requiredHint: "",
      validation: "",
      validationHint: "",
      //-------------------
      maxLength: null,
      prefixIcon: "",
      suffixIcon: "",
      //-------------------

      onMounted: "",
      onChange: "",
      onValidate: "",
    },
  },

  {
    type: "radio",
    label: "单选框",
    hidden: false,
    options: {
      labelAlign: "",
      defaultValue: null,
      displayStyle: "inline",
      buttonStyle: "",
      optionType: "",
      labelWidth: null,
      disabled: false,
      optionItems: [
        { label: "radio 1", value: 1 },
        { label: "radio 2", value: 2 },
        { label: "radio 3", value: 3 },
      ],
      required: false,
      requiredHint: "",
      validation: "",
      validationHint: "",
      //-------------------

      onMounted: "",
      onChange: "",
      onValidate: "",
    },
  },

  {
    type: "checkbox",
    label: "多选框",
    hidden: false,
    options: {
      labelAlign: "",
      defaultValue: [],
      displayStyle: "inline",
      buttonStyle: false,
      optionType: "",
      labelWidth: null,
      disabled: false,
      optionItems: [
        { label: "check 1", value: 1 },
        { label: "check 2", value: 2 },
        { label: "check 3", value: 3 },
      ],
      required: false,
      requiredHint: "",
      validation: "",
      validationHint: "",
      //-------------------

      onMounted: "",
      onChange: "",
      onValidate: "",
    },
  },

  {
    type: "select",
    label: "下拉选择",
    hidden: false,
    options: {
      labelAlign: "",
      defaultValue: null,
      placeholder: "",
      labelWidth: null,
      disabled: false,
      allowClear: true,
      mode: "combobox",
      labelInValue: false,
      showSearch: false,
      fieldNames: JSON.stringify({ label: "", value: "" }),
      queryFunction: JSON.stringify({ path: "", method: "", params: {} }),
      optionItems: [
        { label: "select 1", value: 1 },
        { label: "select 2", value: 2 },
        { label: "select 3", value: 3 },
      ],
      required: false,
      requiredHint: "",
      validation: "",
      validationHint: "",
      //-------------------

      onMounted: "",
      onRemoteQuery: "",
      onChange: "",
      onFocus: "",
      onBlur: "",
      onValidate: "",
    },
  },

  {
    type: "upload",
    label: "文件上传",
    hidden: false,
    options: {
      labelAlign: "",
      labelWidth: null,
      disabled: false,
      required: false,
      requiredHint: "",
      //-------------------
      waterRemark: true,
      directory: false,
      multiple: false,
      showUploadList: true,
      maxCount: 1,
      maxFileSize: 50,
      accept: "image/*",
      //-------------------

      onMounted: "",
      onBeforeUpload: "",
      onUploadSuccess: "",
      onUploadError: "",
      onFileRemove: "",
      onValidate: "",
      //onFileChange: '',
    },
  },

  {
    type: "time",
    label: "时间",
    hidden: false,
    options: {
      labelAlign: "",
      defaultValue: null,
      placeholder: "",
      labelWidth: null,
      inputReadOnly: false,
      disabled: false,
      allowClear: true,
      format: "HH:mm:ss", //时间格式
      required: false,
      requiredHint: "",
      validation: "",
      validationHint: "",
      //-------------------

      onMounted: "",
      onChange: "",
      onFocus: "",
      onBlur: "",
      onValidate: "",
    },
  },

  {
    type: "time-range",
    label: "时间范围",
    hidden: false,
    options: {
      labelAlign: "",
      defaultValue: null,
      startPlaceholder: "开始时间",
      endPlaceholder: "结束时间",
      labelWidth: null,
      inputReadOnly: false,
      disabled: false,
      allowClear: true,
      format: "HH:mm:ss", //时间格式
      required: false,
      requiredHint: "",
      validation: "",
      validationHint: "",
      //-------------------

      onMounted: "",
      onChange: "",
      onFocus: "",
      onBlur: "",
      onValidate: "",
    },
  },

  {
    type: "date",
    label: "日期",
    hidden: false,
    options: {
      labelAlign: "",
      defaultValue: null,
      placeholder: "",
      labelWidth: null,
      inputReadOnly: false,
      disabled: false,
      allowClear: true,
      format: "YYYY-MM-DD", //日期显示格式
      valueFormat: "YYYY-MM-DD", //日期对象格式
      required: false,
      requiredHint: "",
      validation: "",
      validationHint: "",
      //-------------------

      onMounted: "",
      onChange: "",
      onFocus: "",
      onBlur: "",
      onValidate: "",
    },
  },

  {
    type: "date-range",
    label: "日期范围",
    hidden: false,
    options: {
      labelAlign: "",
      defaultValue: null,
      startPlaceholder: "开始日期",
      endPlaceholder: "结束日期",
      labelWidth: null,
      inputReadOnly: false,
      disabled: false,
      allowClear: true,
      format: "YYYY-MM-DD", //日期显示格式
      valueFormat: "YYYY-MM-DD", //日期对象格式
      required: false,
      requiredHint: "",
      validation: "",
      validationHint: "",
      //-------------------

      onMounted: "",
      onChange: "",
      onFocus: "",
      onBlur: "",
      onValidate: "",
    },
  },

  {
    type: "switch",
    label: "开关",
    hidden: false,
    options: {
      labelAlign: "",
      defaultValue: null,
      labelWidth: null,
      disabled: false,
      //-------------------
      switchWidth: 40,
      activeText: "",
      inactiveText: "",
      activeColor: null,
      inactiveColor: null,
      //-------------------

      onMounted: "",
      onChange: "",
      onValidate: "",
    },
  },

  {
    type: "speak",
    label: "语音输出",
    hidden: false,
    options: {
      labelAlign: "",
      rows: 3,
      defaultValue: "",
      placeholder: "",
      labelWidth: null,
      disabled: false,
      required: false,
      requiredHint: "",
      validation: "",
      validationHint: "",
      //-------------------
      maxLength: null,
      showCount: false,
      times: null,
      //-------------------

      onMounted: "",
      onInput: "",
      onChange: "",
      onFocus: "",
      onBlur: "",
      onValidate: "",
    },
  },

  {
    type: "button",
    label: "按钮",
    hidden: false,
    options: {
      disabled: false,
      type: "",
      block: false,
      danger: false,
      shape: "",
      icon: "",
      //-------------------

      onMounted: "",
      onClick: "",
    },
  },

  {
    type: "rich-editor",
    label: "富文本",
    hidden: false,
    options: {
      labelAlign: "",
      placeholder: "",
      labelWidth: null,
      disabled: false,
      required: false,
      requiredHint: "",
      //-------------------
      defaultValue: "",
      uploadFunction: JSON.stringify({ path: "", params: {} }),
      initialFrameHeight: 180, // 高度
      // maxLength: null,
      //-------------------

      onMounted: "",
      onValidate: "",
    },
  },
];

export function addContainerWidgetSchema(containerSchema) {
  containers.push(containerSchema);
}

export function addBasicFieldSchema(fieldSchema) {
  fields.push(fieldSchema);
}
